
<div class="field"  *ngIf="showEmail">
  <mat-label for="email">email:</mat-label>
  <input  id="email" name="email" type="email" [(ngModel)]="paymentParameters.email" [formControl]="emailControl">
  <mat-error
    *ngIf="emailControl.errors">{{getErrorText(emailControl.errors)}}</mat-error>
</div>

